/* eslint-disable class-methods-use-this */

import { ProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';

import { processWildcardString } from '../../utils/proposal';

export default abstract class BaseTextDAO extends ProposalDAO {
  // private methods

  // TODO: this next method should be made recursive to handle multiple keys.

  protected processWildcards(inStr: string, metadata?: ProposalNS.DAOGetTextsMetadata): string {
    let last = '';
    let workStr = inStr;
    while (last !== workStr) {
      last = workStr;
      workStr = processWildcardString(workStr, this.proposal, this.locale, metadata);
    }

    return workStr;
  }
}
